module.exports = __webpack_public_path__ + "assets/img/img309.c3630c6a.png";